import Image from 'next/image';
import { TagWithIcon } from '@components/tag';
import { CookingTimeAndPeopleContainer } from './CookingTimeAndPeople.style';
interface Props {
  cookingTime: string;
  people: string;
}
const CookingTimeAndPeople = ({
  cookingTime,
  people
}: Props) => {
  return <CookingTimeAndPeopleContainer>
            <TagWithIcon icon={<Image src="/icons/timer.svg" alt="icon" width={32} height={32} />} bgColor={"#FDF3EC"} text={cookingTime} />
            <TagWithIcon icon={<Image src="/icons/serves.svg" alt="icon" width={32} height={32} />} bgColor={"#FDF3EC"} text={people} />
        </CookingTimeAndPeopleContainer>;
};
export default CookingTimeAndPeople;